/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adminModelSchema } from "../adminModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAdminsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор")
    })

/**
 * @description Модель администратора
 */
export const getApiAdminsId200Schema = z.lazy(() => adminModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAdminsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAdminsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAdminsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Администратор не найден
 */
export const getApiAdminsId404Schema = z.unknown()

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAdminsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAdminsIdQueryResponseSchema = z.lazy(() => getApiAdminsId200Schema)